/**
 * Module-scoped gate for the /profile Support CTA.
 *
 * Meaning: the prompt was actually presented (modal mounted open) or the user
 * dismissed it this page load. Survives ProfilePage remounts; resets on hard refresh.
 *
 * Do NOT mark on open *attempt* — session hydration can unmount Profile before paint,
 * which would otherwise permanently suppress the CTA for that load.
 */

let supportPromptSettledThisPageLoad = false;

export function hasSettledSupportPromptThisLoad(): boolean {
  return supportPromptSettledThisPageLoad;
}

export function markSupportPromptSettledThisLoad(): void {
  supportPromptSettledThisPageLoad = true;
}

/** @deprecated Use hasSettledSupportPromptThisLoad */
export function hasShownSupportPromptThisLoad(): boolean {
  return hasSettledSupportPromptThisLoad();
}

/** @deprecated Use markSupportPromptSettledThisLoad */
export function markSupportPromptShownThisLoad(): void {
  markSupportPromptSettledThisLoad();
}
